import { render, staticRenderFns } from "./RelationshipRunExplain.vue?vue&type=template&id=d09cb18e&scoped=true"
import script from "./RelationshipRunExplain.vue?vue&type=script&lang=js"
export * from "./RelationshipRunExplain.vue?vue&type=script&lang=js"
import style0 from "./RelationshipRunExplain.vue?vue&type=style&index=0&id=d09cb18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09cb18e",
  null
  
)

export default component.exports